module.exports = __webpack_public_path__ + "images/trauma.e3ec3c3cf5e56e17492dd3f827b21993.svg";